export const errorContext = require.context(".", true, /\_controller.js$/)
